import logoImg from "../../../assets/InstaPass.png";

const sizeMap = {
  sm: "h-5",
  md: "h-7",
  lg: "h-9",
  xl: "h-14",
};

/**
 * Matches new-ui InstaPassLogo sizing (md = h-7).
 */
export function InstaPassLogo({ size = "md", className = "" }) {
  const heightClass = sizeMap[size] ?? sizeMap.md;

  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={logoImg}
        alt="InstaPass"
        className={`${heightClass} w-auto object-contain`}
      />
    </div>
  );
}
